module.exports = __webpack_public_path__ + "img/arrow-down.b4c8bbdc.svg";